import { render, staticRenderFns } from "./m-not-paiban-detail.vue?vue&type=template&id=4d58d7a5&scoped=true&"
import script from "./m-not-paiban-detail.vue?vue&type=script&lang=js&"
export * from "./m-not-paiban-detail.vue?vue&type=script&lang=js&"
import style0 from "./m-not-paiban-detail.vue?vue&type=style&index=0&id=4d58d7a5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d58d7a5",
  null
  
)

export default component.exports